import { Component } from '@angular/core';
import {Store} from "@ngrx/store";
import {Router} from "@angular/router";
import {EventsWebsocketService} from "../../services/entities/events-websocket.service";
import {IconsService} from "../../services/icons.service";
import {selectCameraTarget, selectCameraZoomTarget} from "../../state/camera/camera.selector";
import {selectUser} from "../../state/auth/auth.selector";
import {User} from "../../auth/primitives/user";
import {Vector3} from "three";
import {entityActions} from "../../state/entities/entity.actions";
import { generateUUID } from "three/src/math/MathUtils.js";
import {CollisionType, Components, EntityType} from "../../state/entities/entity.model";
import {PickerComponent} from "@ctrl/ngx-emoji-mart";

@Component({
  selector: 'new-map-reaction',
  standalone: true,
  imports: [PickerComponent],
  templateUrl: './new-map-reaction.component.html',
  styleUrl: './new-map-reaction.component.scss'
})
export class NewMapReactionComponent {

  user: User
  cameraTarget: Vector3 = new Vector3();

  selectedEmoji: string = "";

  constructor(
      private store: Store,
      private router: Router,
      private websocketService: EventsWebsocketService,
      public iconsService: IconsService,
  ) {
    this.store.select(selectCameraTarget).subscribe((target) => {
      this.cameraTarget.copy(target);
    });
    this.store.select(selectCameraZoomTarget).subscribe((target) => {
      // this.cameraZoom = target;
    });
    this.store.select(selectUser)
        .subscribe(async (user) => {
          this.user = user
        })
  }


  closeHolder() {
    this.selectedEmoji = "";
    this.router.navigate([{outlets: {'new-modal-pane': null}}])
  }

  selectEmoji(emoji) {
    this.selectedEmoji = emoji.emoji.native;
  }


  post() {
    this.websocketService.dispatch(
        entityActions.netCreated({
          entity: {
            id: generateUUID(),
            type: EntityType.MapReaction,
            ownerId: this.user.id,
            components: [Components.text, Components.usersTrack],
            coord: new Vector3(
                this.cameraTarget.x,
                this.cameraTarget.y,
                // this.cameraZoom - 700,
                Math.random() * 50,
            ),
            componentProperties: {
              Text: this.selectedEmoji,
              UsersTrack: {
                count: 1,
                userIds: [this.user.id],
              },
            },
            collisionType: CollisionType.Obstacle,
            creationDate: new Date(),
          },
        }),
    );
    this.closeHolder()
  }
}
